import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { LenderProfiles } from '@trnsact/trnsact-shared-types/src/generated';
import { ScoreTierEntity } from 'pages/LenderWaterfall/ScorecardBuilder/types';

import { FinanceProgramForm } from '../../schema';
import { ProgramSettings } from './formSteps/settings';
import { ConfigureStructure } from './formSteps/structure';
import { FinanceCriteriaOptions, FinanceProgramFormSteps } from '../../types';

interface Props {
  isReadOnly: boolean;
  isMultipleLenders?: boolean;
  userType?: 'lender' | 'dealer';
  scoreTiers?: ScoreTierEntity[];
  lendersOptions: LenderProfiles[];
  isLendersSelectDisabled?: boolean;
  dealerVendorProfileOptions?: any[];
  criteriaOptions: FinanceCriteriaOptions[];
  lpsWithOcaAccessByLenderProfileId?: Record<string, LenderProfiles>;
}

export const Form = ({
  userType,
  isReadOnly,
  scoreTiers,
  lendersOptions,
  criteriaOptions,
  isMultipleLenders,
  isLendersSelectDisabled,
  dealerVendorProfileOptions,
  lpsWithOcaAccessByLenderProfileId = {},
}: Props) => {
  const { control } = useFormContext<FinanceProgramForm>();
  const currentStepWatchValue = useWatch({ control, name: 'step' });

  const renderFormStep: Record<FinanceProgramFormSteps, ReactNode> = {
    [FinanceProgramFormSteps.First]: (
      <ProgramSettings
        userType={userType}
        isReadOnly={isReadOnly}
        lendersOptions={lendersOptions}
        criteriaOptions={criteriaOptions}
        isMultipleLenders={isMultipleLenders}
        isLendersSelectDisabled={isLendersSelectDisabled}
        dealerVendorProfileOptions={dealerVendorProfileOptions}
        lpsWithOcaAccessByLenderProfileId={lpsWithOcaAccessByLenderProfileId}
      />
    ),
    [FinanceProgramFormSteps.Second]: <ConfigureStructure isReadOnly={isReadOnly} scoreTiers={scoreTiers} />,
  };

  return <Box className="formSection">{renderFormStep[currentStepWatchValue]}</Box>;
};
